<template>
  <div class="importExcel">
    <div class="row-me">
      <div class="title1">模板下载：</div>
      <div class="column-me flex1">
        <div class="row-me row-center grey-div">
          <img src="../../assets/img/excel.png" class="img-excel">
          <div class="name flex1">{{ name }}</div>
          <div class="btn-blank-blue width110 btn-height40 margin-right20" @click="clickDownload">下载</div>
        </div>
        <div class="row-me row-center margin-top10">
          <img src="../../assets/img/tanhao.png" class="img-icon">
          <div class="title2 margin-left5">请先下载我们提供给您的模板，修改填入数据后再导入文件。</div>
        </div>
      </div>
    </div>
    <div class="row-me row-center margin-top20">
      <div class="title1">导入文件：</div>
      <div class="row-me row-center flex1">
        <div class="file-div">{{ fileName }}</div>
        <el-upload ref="upload" action="" accept=".xls,.xlsx" :show-file-list="false" :auto-upload="false"
                   :http-request="uploadFile" :on-change="fileChange" :limit="2">
          <template #trigger>
            <div class="btn-blank width110 btn-height40 margin-left20">选择文件</div>
          </template>
          <!-- 不加默认上传按钮会报错 -->
          <div class="btn-blue width110 btn-height40" @click="clickOk" v-show="false">确定</div>
        </el-upload>
      </div>
    </div>
    <div class="row-me row-center flex-end1 margin-top100">
      <div class="btn-blank width110 btn-height40" @click="clickCancel">取消</div>
      <el-button class="btn-blue width110 margin-left20" @click="clickOk" :disabled="isSaving">确定</el-button>
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  props: {
    name: { //模板名称
      type: String,
      default: '导入模板[Excel]'
    },
    downloadUrl: { //模板下载链接
      type: String,
      default: ''
    },
    requestUrl: { //上传请求地址
      type: String,
      default: ''
    },
  },
  data() {
    return {
      fileName: '',
      isSaving: false,
    }
  },
  // html加载完成之前
  created() {

  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    //下载
    clickDownload() {
      window.open(this.downloadUrl)
    },
    //确定
    clickOk() {
      if (this.isSaving) return;
      this.isSaving = true
      if (this.fileName === '' || this.fileName === null) {
        this.$message.error('请先选择文件')
        this.isSaving = false
        return
      }
      this.$refs.upload.submit()
    },
    //取消
    clickCancel() {
      this.bus.$emit('importSuccess')
    },
    //文件状态改变
    fileChange(file, fileList) {
      // 解决上传文件limit为1时，不触发onchange方法，在第二次调用的时候将第一个文件删除
      if (fileList.length > 1) {
        fileList.shift();
      }
      this.fileName = file.name
    },
    //上传
    uploadFile(param) {
      this.bus.$emit('loading', 1)
      let file = param.file;
      let formData = new FormData();
      formData.append("file", file);
      this.$uploadFileRequest(this.requestUrl, formData).then((res) => {
        this.bus.$emit('loading', 0)
        if (res) {
          this.$message.success(res.message)
          this.bus.$emit('importSuccess', 'refresh')
        }
        this.isSaving = false
      }).catch((error) => {
        this.bus.$emit('loading', 0)
        this.isSaving = false
        console.log(error)
      })
    },
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
}
</script>

<style lang="scss" scoped>
.importExcel {
  font-size: 18px;
  color: #252630;
  margin: 10px;

  .title1 {
    width: 120px;
  }

  .grey-div {
    height: 100px;
    background-color: #F5F5F5;

    .img-excel {
      width: 50px;
      height: 60px;
      object-fit: scale-down;
      margin-left: 20px;
    }

    .name {
      font-size: 16px;
      margin-left: 20px;
    }
  }

  .img-icon {
    width: 16px;
    height: 16px;
    object-fit: scale-down;
  }

  .title2 {
    font-size: 14px;
    color: #A9B6C4;
  }

  .file-div {
    width: 400px;
    height: 40px;
    line-height: 40px;
    padding: 0 10px;
    border-radius: 4px;
    border: 1px solid #E5E9ED;
  }
}
</style>
